// Single source of truth for which notification `type`s surface in the top-right
// bell (list + unread badge). Shared so the client filter (client/src/lib/
// bell-notifications.ts) and the server unread-count can never drift.
//
// The bell was made mentions-only in Task #3972 (the dashboard Team Inbox owns
// actionable assignment items). PadSplit send-UX re-adds ONE actionable type —
// a terminally-failed outbound message — because a failed send must be
// unmissable for the operator who sent it (the Team Inbox note is the primary
// surface; the bell reinforces it). Keep this list tight: growing it re-opens
// the noise Task #3972 closed.
export const BELL_NOTIFICATION_TYPES = ["mention", "padsplit_message_send_failed"] as const;

const BELL_TYPE_SET: ReadonlySet<string> = new Set(BELL_NOTIFICATION_TYPES);

export function isBellNotificationType(type: string | null | undefined): boolean {
  return type != null && BELL_TYPE_SET.has(type);
}
